import { Props } from "."

export const mockProps: Props = {
  onClick: () => {},
  children: "Click me",
}
